<template>
  <div>
    <table class="print-table">
      <caption>
        <div v-if="tableTitleArr.length > 1" class="table-title">
          <span v-for="(item, index) in tableTitleArr" :key="index">
            <span v-if="index === 1">(</span>
            <span :class="item.isActive ? 'c-green' : ''">{{ item.name }}</span>
            <span v-show="index !== 0 && !item.isActive && item.name" class="m-x-2">&gt;</span>
            <span v-if="index === tableTitleArr.length - 1">)</span>
          </span>
        </div>
        <div v-else class="table-title">
          <span class="c-green">销售清单</span>
        </div>
      </caption>
      <thead>
        <tr>
          <th width="24">序号</th>
          <th width="84">商品名称</th>
          <!-- <th width="48">材质</th> -->
          <th width="108">规格</th>
          <th width="60">单位</th>
          <th width="60">数量</th>
          <th width="80">商品单价</th>
          <th width="80">商品金额</th>
          <th width="80" v-if="!parent">销售单价</th>
          <th v-if="!parent">销售金额</th>
          <th v-if="parent">每套零件数量</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in selfData" :key="index">
          <td>{{ index + 1 }}</td>
          <td>{{ item.name }}</td>
          <!-- <td>{{ item.texture }}</td> -->
          <td>{{ item.spec }}</td>
          <td>{{ item.unit }}</td>
          <td>{{ item.counts }}</td>
          <td>¥{{ item.goods_price }}</td>
          <td>¥{{ item.goods_amount }}</td>
          <td v-if="!parent">¥{{ item.sales_price }}</td>
          <td v-if="!parent">¥{{ item.sales_amount }}</td>
          <td v-if="parent">{{ item.counts_unit }}</td>
        </tr>
      </tbody>
    </table>
    <template v-for="(item, index) in selfData">
      <PrintTable
        v-if="item.tableBomData.length"
        :key="index"
        :tableTitle="`${tableTitle}-${item.name}`"
        :parent="item"
        :data="item.tableBomData"
      />
    </template>
  </div>
</template>

<script>
export default {
  name: 'PrintTable',
  props: {
    tableTitle: {
      type: String,
      required: true
    },
    parent: {
      type: Object,
      default: () => {
        return null
      }
    },
    data: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      selfData: []
    }
  },
  computed: {
    // 表格标题
    tableTitleArr() {
      let arr = this.tableTitle.split('-')
      let result = arr.map((item, index) => {
        return {
          name: item,
          isActive: index === arr.length - 1
        }
      })
      return result
    }
  },
  mounted() {
    this.selfData = this.$util.deepCopy(this.data)
  }
}
</script>

<style lang="less" scoped>
.print-table {
  margin-top: 10px;
  width: 100%;
  border-collapse: collapse;
  border-left: 1px solid #000;
  border-top: 1px solid #000;
  text-align: center;
}
.print-table caption {
  padding-bottom: 5px;
  text-align: left;
  font-weight: bold;
}
.print-table th,
.print-table td {
  border-right: 1px solid #000;
  border-bottom: 1px solid #000;
  padding: 2px;
  overflow-wrap: anywhere;
}
.print-table th {
  font-weight: normal;
  background: #e0e5eb;
}
</style>
